"use client";

import RouteCard from "@/components/pages/ferry/cards/RouteCard";
import ContactInfoCard from "@/components/featured/bus/cards/ContactInfoCard";
import IconTextCard from "@/components/pages/ferry/cards/IconTextCard";
import { BlogCard } from "@/components/featured/common";
import GoogleMapCard from "@/components/featured/bus/cards/GoogleMapCard";

export const componentRegistry = {
  RouteCard,
  ContactInfoCard,
  IconText: IconTextCard,
  BlogCard,
  GoogleMapCard,
};

export const itemPropMapping = {
  RouteCard: "item",
  ContactInfoCard: "items",
  IconText: "item",
  BlogCard: "post",
};
